import { useCallback, useEffect, useMemo } from "react";
import throttle from "lodash/throttle";

import { useEditorState } from "@/store";

import sessionSocket from "@/singletons/SessionSocket";

export const ScreenActivity = () => {
  const { shutDown: sh } = useEditorState();

  const heartbeat = useCallback(() => {
    if (sh) return;
    sessionSocket.sendHeartbeat();
  }, [sh]);

  const debouncedHeartbeat = useMemo(() => {
    return throttle(heartbeat, 30_000, {
      leading: true,
      trailing: false,
    });
  }, [heartbeat]);

  useEffect(() => {
    const handleActivity = () => debouncedHeartbeat();

    if (!sh) {
      window.addEventListener("keydown", handleActivity);
      window.addEventListener("mousedown", handleActivity);
      window.addEventListener("touchstart", handleActivity);
      window.addEventListener("wheel", handleActivity);
      window.addEventListener("pointerdown", handleActivity);
    }

    return () => {
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("mousedown", handleActivity);
      window.removeEventListener("touchstart", handleActivity);
      window.removeEventListener("wheel", handleActivity);
      window.removeEventListener("pointerdown", handleActivity);
      debouncedHeartbeat.cancel();
    };
  }, [sh, debouncedHeartbeat]);

  return null;
};
